import EventEmitter from 'events';

class Emitter {
  constructor() {
    this.instance = new EventEmitter();
    this.instance.setMaxListeners(100);
  }
}

export default new Emitter();
